import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 * Only allows safe HTML tags and attributes (e.g., for iframe embeds)
 * @param {string} html - Raw HTML string
 * @returns {string} - Sanitized HTML string
 */
export const sanitizeHTML = (html) => {
    if (!html || typeof html !== 'string') {
        return '';
    }

    // Configuration for DOMPurify
    const config = {
        ALLOWED_TAGS: ['iframe', 'p', 'br', 'strong', 'em', 'b', 'i', 'a', 'div', 'span', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        ALLOWED_ATTR: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen', 'href', 'target', 'rel', 'class'],
        ALLOW_DATA_ATTR: false,
        SAFE_FOR_TEMPLATES: true,
    };

    return DOMPurify.sanitize(html, config);
};

/**
 * Vue 3 directive for safe HTML rendering
 * Usage: v-safe-html="htmlContent"
 */
export const vSafeHtml = {
    mounted(el, binding) {
        el.innerHTML = sanitizeHTML(binding.value);
    },
    updated(el, binding) {
        el.innerHTML = sanitizeHTML(binding.value);
    }
};

export default {
    sanitizeHTML,
    vSafeHtml
};
